// Decide qué plantilla del escrito de Amparo PNC corresponde según los datos del trámite, y arma
// los avisos que hay que mostrar antes de descargar. Compartido entre ModalGenerarAmparoPnc (alta y
// ficha), para no duplicar la lógica ni los textos entre los dos puntos de entrada. Espejo (en el
// frontend) de AmparoPncEscritoService.resolverPlantilla en el backend — si cambia el criterio ahí,
// hay que cambiarlo acá también.
//
// SOLO ANDIS DESDE V239. La variante ANSES se mudó al módulo Amparo por mora (modulos/amparo), que
// sí sabe por qué trámite previsional se ampara y puede llenar el renglón del tipo de trámite que
// acá salía siempre en blanco. Un Amparo PNC con organismo = ANSES es en realidad de ese otro tipo:
// el aviso de abajo dice qué hacer, y el backend devuelve el mismo mensaje si se intenta igual.
export function resolverPlantillaAmparo({ organismo, tieneCopiaCmo }) {
    if (organismo === 'ANSES') {
        return {
            clave: null,
            titulo: null,
            avisos: [
                'El escrito de amparo por mora ante ANSES se emite desde el trámite de Amparo por mora, no desde Amparo PNC. Convertí este trámite con "Cambiar tipo" a Amparo por Mora (ANSES) —te va a pedir por qué trámite se ampara— y generá el escrito desde ahí, con el tipo de trámite ya completo.',
            ],
        };
    }

    if (organismo === 'ANDIS') {
        if (tieneCopiaCmo) {
            return {
                clave: 'ANDIS_CON_CMO',
                titulo: 'Amparo por mora ante ANDIS — con copia del CMO',
                avisos: [],
            };
        }
        return {
            clave: 'ANDIS_SIN_CMO',
            titulo: 'Amparo por mora ante ANDIS — sin copia del CMO',
            avisos: [
                'Como todavía no se cuenta con copia del CMO, el escrito suma el pedido de exhibición del Certificado Médico Oficial (art. 388 CPCCN).',
            ],
        };
    }

    return {
        clave: null,
        titulo: null,
        avisos: ['Seleccioná el organismo ANDIS en los datos del trámite para poder generar el escrito de amparo de PNC.'],
    };
}
